/**
 * Converte caracteres de quebra de linha (\n) em tags HTML <br />
 * para exibição correta quando usado com HTMLReactParser
 * @param text Texto com caracteres de quebra de linha
 * @returns Texto formatado com tags <br /> no lugar dos \n
 */
export const formatarQuebrasLinha = (text?: string): string => {
  if (!text) return '';
  
  // Substitui todos os \n por <br />
  return text.replace(/\n/g, '<br />');
};